
import React from "react";
import { Home, Award } from "lucide-react";
import {
  Accordion
} from "@/components/ui/accordion";
import FAQItem from "./FAQItem";

const PropertyManagementFAQ = () => {
  return (
    <div className="mb-8">
      <h3 className="text-xl font-semibold mb-4 theme-primary-text flex items-center">
        <Home className="h-5 w-5 mr-2" />
        Quản Lý Bất Động Sản
      </h3>
      <Accordion type="single" collapsible className="space-y-4">
        <FAQItem 
          value="item-2"
          icon={Award}
          question="Điều gì làm cho quy trình sàng lọc khách thuê của bạn tốt hơn?"
          answer="Sàng lọc cao cấp của chúng tôi vượt xa kiểm tra tín dụng và lý lịch tiêu chuẩn. Chúng tôi sử dụng phân tích hành vi tiên tiến, xác minh việc làm, phân tích lịch sử thuê và tham chiếu nhân vật. Cách tiếp cận toàn diện này đã dẫn đến tỷ lệ giữ chân khách thuê 98% và vấn đề thanh toán tối thiểu."
        />
        <FAQItem 
          value="item-3"
          icon={Home}
          question="Những dịch vụ bảo trì nào được bao gồm trong phí của bạn?"
          answer="Gói tiêu chuẩn của chúng tôi bao gồm tất cả bảo trì thường xuyên, phản hồi khẩn cấp 24/7 và kiểm tra bảo trì phòng ngừa hàng năm. Chúng tôi xử lý mọi thứ từ sửa chữa nhỏ đến điều phối với nhà thầu cho các vấn đề lớn hơn, tất cả trong khi giữ cho bạn được thông báo qua bảng điều khiển kỹ thuật số của chúng tôi."
        />
        <FAQItem 
          value="item-7"
          icon={Award}
          question="Tại sao gói Premium đáng giá chi phí thêm?"
          answer="Gói Premium (15%) bao gồm toàn bộ dịch vụ quản lý nâng cao: tìm khách chuyên nghiệp với marketing đa kênh, sàng lọc 5 bước nghiêm ngặt, thu tiền tự động, hỗ trợ 24/7, bảo trì ưu tiên, kiểm tra định kỳ hàng quý và vệ sinh chuyên sâu hàng năm. So với gói Standard (8%), chênh lệch chỉ khoảng 1.050.000đ cho căn hộ thuê 15 triệu/tháng nhưng bạn được quản lý toàn diện, giảm thiểu trống nhà và bảo toàn giá trị tài sản dài hạn."
        />
      </Accordion>
    </div>
  );
};

export default PropertyManagementFAQ;
